var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"curtains",class:{ open: _vm.open }},[_c('div',{staticClass:"curtain-left"}),_c('div',{staticClass:"curtain-right"})])}
var staticRenderFns = []

export { render, staticRenderFns }